import { Modal } from "shared/ui/modal";
import { Button } from "shared/ui/button";
import styles from "./EventRegistrationModal.module.scss";

export const EventRegistrationModal = ({
  isModalOpen,
  open,
  close,
  toggle,
}) => {
  return (
    <Modal isModalOpen={isModalOpen} open={open} close={close} toggle={toggle}>
      <div className={styles.modalContent}>
        <p className={styles.modalContent__title}>
          Ваша заявка на регистрацию принята!
        </p>
        <p className={styles.modalContent__text}>
          Ожидайте звонка менеджера для уточнения деталей и оплаты билета.
        </p>
        <div className={styles.modalContent__button}>
          <Button variant="primary" size="large" onClick={close}>
            Спасибо!
          </Button>
        </div>
      </div>
    </Modal>
  );
};
